<template>
    <v-container fluid>
        <!-- Delete Group Dialog -->
        <DeleteDialog
            :dialog.sync="deleteGroupDialog"
            :item="tenantUserGroup"
            v-on:confirmed="deleteGroupConfirmed"
        >
            <template v-slot:title>Delete - {{ tenantUserGroup.name }}</template>
            <template v-slot:content>Are you sure you want to delete this group?</template>
        </DeleteDialog>

        <!-- Group Dialog-->
        <TenantUserGroupEditDialog
            :object.sync="tenantUserGroup"
            :dialog.sync="tenantUserGroupDialog"
        ></TenantUserGroupEditDialog>

        <!-- Main -->
        <v-row class="align-center">
            <!-- Breadcrumbs -->
            <v-breadcrumbs
                :items="[{text: 'Home', disable: false, href: '/#/'}, {text: 'Groups', disable: false, href: '/#/groups'}, {text: tenantUserGroup.name, disabled: true}]"
                divider="/"
            ></v-breadcrumbs>

            <v-spacer></v-spacer>
            <v-btn
                v-if="hasPermission('change_tenantusergroup')"
                color="primary"
                class="mr-2"
                rounded
                outlined
                small
                @click="tenantUserGroupDialog=true"
            >RENAME</v-btn>

            <v-btn
                v-if="hasPermission('delete_tenantusergroup')"
                color="error"
                class="mr-8"
                rounded
                outlined
                small
                @click="deleteGroupDialog=true"
            >DELETE GROUP</v-btn>
        </v-row>

        <TenantUserGroupDetailComponent
            :tenantUserGroupNodeId="$route.params.id"
            v-on:item-fetched="onTenantUserGroupFecthed"
            v-on:item-deleted="onTenantUserGroupDeleted"
        ></TenantUserGroupDetailComponent>
    </v-container>
</template>

<script>
import helper from "@/utils/helper.js";
import DeleteDialog from "@/components/base/DeleteDialog.vue";
import TenantUserGroupDetailComponent from "@/components/tenants/TenantUserGroupDetailComponent.vue";
import TenantUserGroupEditDialog from "@/components/tenants/TenantUserGroupEditDialog.vue";

export default {
    name: "tenant-user-group-detail-page",
    components: {
        TenantUserGroupDetailComponent,
        TenantUserGroupEditDialog,
        DeleteDialog
    },

    data() {
        return {
            tenantUserGroupDialog: false,
            deleteGroupDialog: false,
            tenantUserGroup: {}
        };
    },
    computed: {},
    watch: {},
    created() {
        this.hasPermission = helper.hasPermission;
    },
    methods: {
        onTenantUserGroupFecthed(response) {
            this.tenantUserGroup = response;
        },
        onTenantUserGroupDeleted() {
            // redirect to products list page
            this.$router.push("/groups");
        },

        deleteGroupConfirmed() {
            if (this.tenantUserGroup) {
                const payload = {
                    id: this.tenantUserGroup.id
                };
                this.$store
                    .dispatch("tenants/deleteTenantUserGroup", payload)
                    .then(response => {
                        // close delete dialog
                        this.$router.push("/groups");

                        // show snackbar
                        const payload = {
                            color: "success",
                            message: `${response.name} is deleted!`
                        };
                        this.$store.dispatch("snackbar/showMessage", payload);
                    })
                    .catch(error => {
                        this.error = error.graphQLErrors[0].message;
                    });
            }
        },

        selectAllPermissions() {

        }
    }
};
</script>